import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared';

import { homeState, HomeComponent } from './';

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild([ homeState ])
    ],
    declarations: [
        HomeComponent,
    ],
    entryComponents: [
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeModule {}



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts